import { getPartyIdFromStorage } from "../storage/storage";

const COOKIE_NAME = "connect.sid";
const capturePartyFromUrlRegex = /\/p\/([a-zA-Z0-9-_]+)/;

export const getPartyIdFromUrl = (url) => {
  const matches = url.match(capturePartyFromUrlRegex);
  if (matches) {
    return matches[1];
  }
  return null;
};

export const getUserId = () => {
  const serverCookie = getPartyIdFromStorage(COOKIE_NAME);
  if (serverCookie) {
    return serverCookie;
  } else {
    return Math.random()
      .toString()
      .substring(2);
  }
};

export const getParamPairs = (path) => {
  return path
    .substring(path.lastIndexOf("?") + 1)
    .split("&")
    .reduce((acc, paramPairString) => {
      const paramPairs = paramPairString.split("=");
      acc[paramPairs[0]] = paramPairs[1];
      return acc;
    }, {});
};

export const getTruncatedString = (
  string,
  { length = 42, suffix = "..." } = {},
) => {
  return string.length > length ? string.substring(0, length) + suffix : string;
};

export const getIdFromUri = (uri) =>
  uri ? uri.substring(uri.lastIndexOf(":") + 1) : "";

export const getParamString = (paramsMap) => {
  return Object.keys(paramsMap).reduce((acc, key, index) => {
    const prefix = index === 0 ? "?" : "&";
    return `${acc}${prefix}${key}=${paramsMap[key]}`;
  }, "");
};

export const validatePartyName = (string) => {
  const partyNameValidationPattern = /^[a-zA-Z0-9_]+$/;
  return partyNameValidationPattern.test(string);
};
